import ToiletTypes from '@/enums/toiletTypes';
import ambulatory from '@/shared/icons/ambulatory/ambulatory.vue';
import disability from '@/shared/icons/disability/disability.vue';
import man from '@/shared/icons/man/man.vue';
import mixedToilet from '@/shared/icons/mixedToilet/mixedToilet.vue';
import woman from '@/shared/icons/woman/woman.vue';

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'hadrianToiletType',
  components: {
    man,
    woman,
    ambulatory,
    disability,
    mixedToilet,
  },
  props: {
    svgClass: {
      type: String,
      default: '',
    },
    toiletType: {
      type: String,
    },
  },
  methods: {
    isCorrectIcon(iconType: string) {
      return iconType === this.toiletType;
    },
  },
  data() {
    return {
      types: ToiletTypes,
    };
  },
});
